import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue'
import RankingChart, { RankingItem } from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-blocking-ranking-chart',
  props: {
    data: { default: () => [] },
    timeRange: { default: TimeRange.ALL }
  },
  emits: ["update:timeRange", "itemClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const loading = ref(false)

const timeRange = computed({
  get: () => props.timeRange,
  set: (val) => emit('update:timeRange', val)
})

__expose({
  loading
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('accessRestriction.terminalBlockRank'),
    data: _ctx.data,
    "time-range": timeRange.value,
    "onUpdate:timeRange": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
    loading: loading.value,
    "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
    unit: _ctx.$t('accessRestriction.unitTimes'),
    "name-key": "name",
    "row-clickable": "",
    onItemClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('itemClick', $event)))
  }, {
    "item-name": _withCtx(({ item }: { item: RankingItem & { rank: number } }) => [
      _createTextVNode(_toDisplayString(item.name) + " (" + _toDisplayString(item.department) + ") ", 1)
    ]),
    _: 1
  }, 8, ["title", "data", "time-range", "loading", "unit"]))
}
}

})